// 记牌：只用公开信息（自己的手牌 + 本副桌上打出的牌）算出“还没见过的牌”。记牌器界面与高手机器人共用。
import { BIG_JOKER, SMALL_JOKER } from './cards.ts';
import type { Card } from './cards.ts';

export const COUNTER_RANKS = [BIG_JOKER, SMALL_JOKER, 14, 13, 12, 11, 10, 9, 8, 7, 6, 5, 4, 3, 2];

/** 每个点数还没见过的张数（两副牌：每个点数 8 张，大小王各 2 张）。 */
export function unseenCounts(hand: Card[], played: Card[]): Map<number, number> {
  const left = new Map(COUNTER_RANKS.map((r) => [r, r >= SMALL_JOKER ? 2 : 8]));
  for (const c of [...hand, ...played]) left.set(c.rank, (left.get(c.rank) ?? 0) - 1);
  return left;
}

/** 还没见过的牌里有没有单张比 power 大的（不算炸弹）。powerOf 由调用方按级牌换算。 */
export function anyHigherUnseen(unseen: Map<number, number>, power: number, powerOf: (rank: number) => number): boolean {
  for (const [rank, n] of unseen) if (n > 0 && powerOf(rank) > power) return true;
  return false;
}
